<script>
import baseMixin from '@/mixins/baseMixin'
import { FormField } from '@/models/forms/fields/formField'
import InfoLabel from '../general/info-label.vue'

export default {
  name: 'FormSubmissionDefaultField',
  components: {
    InfoLabel,
  },
  mixins: [baseMixin],
  props: {
    field: {
      type: FormField,
      required: true,
    },
    value: {
      required: true,
    },
  },
}
</script>

<template>
  <div>
    <InfoLabel :label="field.label">
      <span class="font-weight-medium">{{ value }}</span>
    </InfoLabel>
  </div>
</template>
